import posthog, { Properties } from 'posthog-js'

let isInitialized = false

if (!window.location.href.includes('localhost')) {
  if (import.meta.env.VITE_POSTHOG_KEY) {
    posthog.init(
      import.meta.env.VITE_POSTHOG_KEY,
      import.meta.env.VITE_POSTHOG_HOST
        ? {
            api_host: import.meta.env.VITE_POSTHOG_HOST,
          }
        : undefined, // use default host from posthog-js, its app.posthog.com
    )
    isInitialized = true
  } else {
    console.warn('VITE_POSTHOG_KEY is not set, posthog will not be initialized')
  }
} else {
  console.warn('Posthog will not be initialized in development mode')
}

export function capture(
  eventName: string,
  properties?: Properties | undefined,
  options?: { transport: 'XHR' | 'sendBeacon' } | undefined,
) {
  if (isInitialized) {
    return posthog.capture(eventName, properties, options)
  }
}

export function identify(
  uniqueId?: string | undefined,
  userPropertiesToSet?: Properties | undefined,
  userPropertiesToSetOnce?: Properties | undefined,
) {
  if (isInitialized) {
    return posthog.identify(uniqueId, userPropertiesToSet, userPropertiesToSetOnce)
  }
}
